import { isArrayNotEmpty } from '@/common/util/util';
import { ALL_BUTTON_POSITION_LIST } from '@/common/manager/position/button-position';
export const config = {
    value: 'treeReload',
    position: ALL_BUTTON_POSITION_LIST,
    action: (arg) => {
        const { buttonConfig, _context } = arg || {};
        const { options } = buttonConfig || {};
        const { _bindTree } = options || {};
        function reloadOneTree(id) {
            if (typeof id === 'string') {
                const tree = _context?.$(id);
                tree?.load?.();
            }
        }
        if (isArrayNotEmpty(_bindTree) && _context) {
            _bindTree.forEach((item) => {
                reloadOneTree(item);
            });
        }
    },
};
